import React, { useEffect, useState } from "react";
import "./UiConfig.css";
import { useUiConfigOption } from "../../providers/UiConfigOptionProvider";
import { setManageRoleState } from "../../stateManagement/actions/manageRoleAction";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { useNavigate } from "react-router-dom";
import {
  getMetaDataConfig,
} from "../../services/uiConfigService";
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import NewPortalLayout from "../../components/newPortal/NewPortalLayout";
import { configurationAttributeType } from "../../types";
import * as Sentry from "@sentry/react";
import OptionalFeatureLayout from "../salescodeStudio/mandatoryConfigs/optionalFeatures/OptionalFeatureLayout";
import Loader from "../../components/loading/Loader";

const UiConfigNew = () => {
  const [loader, setIsloader] = useState<boolean>(false);
  const [isStandardSubscription, setisStandardSubscription] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const { activeOption } = useUiConfigOption();

  useEffect(() => {
    async function getAndSetRoles() {
      const appRoles: string[] = [];
      const clientConfig = await getMetaDataConfig("clientconfig");
      clientConfig.forEach((configObj: { domainType: string }) => {
        if (configObj.domainType.endsWith("app_feature_configuration")) {
          const index = configObj.domainType.lastIndexOf("app");
          const roleName = configObj.domainType.substring(0, index - 1);
          appRoles.push(roleName);
        }
      });
      setManageRoleState({ allRoles: appRoles });
      if (appRoles.length === 0) {
        openPopup(
          "Alert",
          "First create atleast one role for App to access UI Config",
          () => {
            navigate("/dashboard/manageRole");
          }
        );
      }
    }
    getAndSetRoles();
    setAppSubscription();
    logEvent(eventEnum.ui_config_click, {
      feature_name: "UI config",
      dashboard_name: "Salescode studio",
    });
  }, []);

  async function setAppSubscription() {
    try {
      setIsloader(true);
      const portalConfig = await getMetaDataConfig(
        "clientconfig",
        "portal_configuration"
      );
      const portal_config: configurationAttributeType[] =
        portalConfig?.domainValues;
      const subscriptionType =
        portal_config.find((item) => item.name === "subscriptionType")
          ?.value! === "standard";
      setIsloader(false);
      setisStandardSubscription(subscriptionType);
    } catch (err) {
      setIsloader(false);
      Sentry.captureException(err);
    }
  }

  return (
    <>
      {loader ? (
        <>
          <Loader></Loader>
        </>
      ) : (
        <div className={`main_container active-options`}>
          <NewPortalLayout disableHeader={true}>
            <OptionalFeatureLayout disableBack={true}>
              {" "}
              {activeOption.targetComponent}
            </OptionalFeatureLayout>
          </NewPortalLayout>
        </div>
      )}
    </>
  );
};

export default UiConfigNew;
